import axios from "axios";

// Configuración base
export const BASE_URL = "https://api.revistaguineo.com/api"; // Cambiar a http://localhost:5000/api para desarrollo
export const PUBLIC_URL = `${BASE_URL}/public`;

export const getImageUrl = (path) => {
  if (!path) return '';

  let finalPath = path;
  if (typeof path === 'object') {
    finalPath = path.file || path.url || path.path || path.src || path.image || '';
  }

  if (typeof finalPath !== 'string' || !finalPath) return '';

  if (finalPath.startsWith('http') || finalPath.startsWith('data:') || finalPath.startsWith('blob:')) return finalPath;
  return `${BASE_URL}${finalPath.startsWith('/') ? '' : '/'}${finalPath}`;
};

axios.defaults.baseURL = BASE_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

// Interceptor para añadir el token a TODAS las peticiones
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar 401 → logout automático
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      window.location.href = "/authentication/sign-in";
    }
    return Promise.reject(error);
  }
);

export default axios;